import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { QuestionAnswerResponse } from "../timeline/user-requests/user-request.types";
import { firstValueFrom, Observable } from "rxjs";
import { Poll } from "./polls.type";
import { RichTextComment } from "@teammood/timeline";
import Delta from "quill-delta";
import { PollTrends } from "./user-polls/user-polls.type";

@Injectable()
export class PollService {
    constructor(
        private http: HttpClient,
    ){}

    getPoll(pollId: string): Observable<Poll> {
        return this.http.get<Poll>(`/api/poll/${pollId}`);
    }

    postUserCommentToPoll(pollId: string, comment: Delta){
        return this.http.put<QuestionAnswerResponse>('/api/question/comment/new', { pollId: pollId, comment: comment});
    }

    getTrends(pollId: string) {
        return this.http.get<PollTrends>(`/api/poll/trend/${pollId}`);
    }
}

